import React from 'react';
import './Footer.css';
import { BsInstagram, BsWhatsapp, BsEnvelopeFill } from 'react-icons/bs';

const Footer = () => {
  return (
    <footer className="footer">

      <div className="footer-top">

        <div className="footer-brand">
          <div className="footer-logo">PORT<span>FOLIO</span></div>
          <p className="footer-tagline">
            Deepak Kumar — Creative Graphic Designer<br />
            based in Karnal, Haryana
          </p>
        </div>

        <div className="footer-links">
          <h4 className="footer-links-title">Quick Links</h4>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#projects">Projects</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-social">
          <h4 className="footer-links-title">Connect</h4>
          <div className="social-icons">
            <a href="https://instagram.com/mr_designer79"
              target="_blank" rel="noreferrer"
              className="social-icon">
              <BsInstagram />
            </a>
            <a href="https://wa.me/917988325166"
              target="_blank" rel="noreferrer"
              className="social-icon">
              <BsWhatsapp />
            </a>
            <a href="mailto:dkumar41413@gmail.com"
              className="social-icon">
              <BsEnvelopeFill />
            </a>
          </div>
          <p className="footer-email">dkumar41413@gmail.com</p>
        </div>

      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-line"></div>
        <div className="footer-bottom-content">
          <span className="footer-copy">
            © 2024 Deepak Kumar. All rights reserved.
          </span>
          
        </div>
      </div>

    </footer>
  );
};

export default Footer;